@import '../../styles/host.css';

:host {
    display: block;
}

.protean-optgroup-label {
    position: relative; /* sticky later */
    z-index: 1;
    top: 0;
    display: flex;
    align-items: center;
    min-height: 2.5rem;
    font-weight: 500;
    background-color: var(--protean-dropdown-background-color, #1a1a1a);
}

.protean-optgroup-label::before {
    content: '';
    width: calc(100% - 30px);
    height: 1px;
    position: absolute;
    top: 50%;
    left: 15px;
    background-color: var(--protean-optgroup-separator-color, #535353);
}

.protean-optgroup-label-text {
    display: inline-block;
    margin-left: 1.5rem;
    padding: 0 0.5rem;
    background-color: var(--protean-dropdown-background-color, #1a1a1a);
    position: relative;
    font-style: italic;
}

:host([disabled]) .protean-optgroup-label-text span {
    opacity: 0.4;
}
